import React from 'react';
import { useIntl } from 'react-intl';
import * as PropTypes from 'prop-types';

import Button from '../../Button';
import SingleSelect from '../../common/SingleSelect';

import usePCPForm from './hooks/usePCPForm';

import styles from './index.styl';

const PrimaryCareProviderForm = ({ handleNext, initialPCPAnswer }) => {
  const { formatMessage } = useIntl();

  const { pcpAnswer, handleOptionChange, optionsList } = usePCPForm(
    initialPCPAnswer,
  );

  const onSubmit = e => {
    e.preventDefault();
    handleNext(pcpAnswer);
  };

  return (
    <form onSubmit={onSubmit}>
      <SingleSelect
        name="pcpQ"
        list={optionsList}
        radioInputClass={styles.list}
        onChange={handleOptionChange}
        selectedValue={pcpAnswer}
      />

      <div className="mt4 tr">
        <Button
          type="submit"
          raised
          color="primary"
          disabled={!pcpAnswer}
          className={styles.button}
        >
          {formatMessage({ id: 'common.next' })}
        </Button>
      </div>
    </form>
  );
};

PrimaryCareProviderForm.propTypes = {
  handleNext: PropTypes.func.isRequired,
  initialPCPAnswer: PropTypes.string,
};

export default PrimaryCareProviderForm;



// WEBPACK FOOTER //
// ./src/components/forms/PrimaryCareProviderForm/index.jsx